import { defineAsyncComponent } from 'vue'

// @comark/vue ships the comark markdown parser with its renderer. Loading it on demand keeps
// the parser out of every page that could render markdown but usually does not.
export const AsyncMarkdownDocument = defineAsyncComponent(() => import('@comark/vue').then(m => m.MarkdownDocument))
